import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  currAdress,
  updateAddress,
} from "../../redux/authentication/AuthenticationSlice";
import { Baseurl } from "../../config/BaseUrl";
import {
  FaEdit,
  FaPlus,
  FaCrosshairs,
  FaCheck,
  FaMapMarkerAlt,
  FaChevronLeft,
} from "react-icons/fa";

const Address = () => {
  const { address, currentAddress, loginData } = useSelector(
    (store) => store.Authentication
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [modalVisible, setModalVisible] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectAddress, setSelectAddress] = useState("");
  const [addressShow, setAddressShow] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addressForm, setAddressForm] = useState({
    HNo: "",
    AName: "",
    StreetDet: "",
    AreaDet: "",
    LandMark: "",
    City: "",
    State: "Telangana",
    Pincode: "",
    Mobile: "",
    Type: "Home",
  });
  const [formErrors, setFormErrors] = useState({});
  const [addLoading, setAddLoading] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);

  useEffect(() => {
    const fetchAddress = async () => {
      const url = `${Baseurl}/api/v1/client/addressbyid/${loginData._id}`;
      const getaddress = await axios.get(url);
      if (getaddress.data.success) {
        const addressfetch = getaddress.data.client.Addresses;
        setAddressShow(addressfetch);
        dispatch(updateAddress(addressfetch));
        if (addressfetch.length > 0) {
          dispatch(currAdress(addressfetch[0]));
          setSelectedAddressId(addressfetch[0]._id);
        }
      }
    };

    fetchAddress();
  }, [loginData]);

  // Get current location
  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported"));
        return;
      }
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };

  // Auto-fill address from current location
  const autoFillFromLocation = async () => {
    setLocationLoading(true);
    try {
      const position = await getCurrentLocation();
      const { latitude, longitude } = position.coords;

      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`
      );
      const data = await response.json();

      if (data && data.address) {
        const addr = data.address;
        setAddressForm((prev) => ({
          ...prev,
          HNo: addr.house_number || addr.house || "",
          StreetDet: addr.road || "",
          AreaDet: addr.suburb || addr.neighbourhood || "",
          City: addr.city || addr.town || addr.village || "",
          State: addr.state || "Telangana",
          Pincode: addr.postcode || "",
          AName: addr.suburb || addr.city || "",
        }));
      }
    } catch (error) {
      alert("Unable to get your location. Please enter address manually.");
    } finally {
      setLocationLoading(false);
    }
  };

  // Validation function
  const validateForm = () => {
    const errors = {};
    if (!addressForm.HNo) errors.HNo = "House number is required";
    if (!addressForm.AName) errors.AName = "Area name is required";
    if (!addressForm.AreaDet) errors.AreaDet = "Area details are required";
    if (!addressForm.City) errors.City = "City is required";
    if (!addressForm.Pincode || addressForm.Pincode.length !== 6)
      errors.Pincode = "Valid 6-digit pincode is required";
    if (!addressForm.Mobile || addressForm.Mobile.length !== 10)
      errors.Mobile = "Valid 10-digit mobile number is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const deleteClick = async () => {
    setIsDeleting(true);
    try {
      const formData = {
        ClientId: loginData._id,
        addressId: selectAddress._id,
      };

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const url = `${Baseurl}/api/v1/client/deleteclientsingleaddress`;
      const addAddress = await axios.put(url, formData, config);

      if (addAddress.data.success === true) {
        const lastaddress = addAddress.data.client;
        const updatedAddresses = lastaddress.Addresses;
        dispatch(updateAddress(updatedAddresses));
        setAddressShow(updatedAddresses);

        if (
          currentAddress._id === selectAddress._id &&
          updatedAddresses.length > 0
        ) {
          dispatch(currAdress(updatedAddresses[0]));
          setSelectedAddressId(updatedAddresses[0]._id);
        } else if (updatedAddresses.length === 0) {
          dispatch(currAdress({}));
          setSelectedAddressId(null);
        }

        setModalVisible(false);
      }
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleAddAddress = async () => {
    if (!validateForm()) return;
    setAddLoading(true);

    try {
      const formData = {
        AName: addressForm.AName,
        Number: addressForm.Mobile,
        Pincode: parseInt(addressForm.Pincode),
        State: addressForm.State,
        City: addressForm.City,
        HNo: addressForm.HNo,
        StreetDet: addressForm.StreetDet,
        LandMark: addressForm.LandMark,
        AreaDet: addressForm.AreaDet,
        Type: addressForm.Type,
        Tag: "",
        prime: false,
        Mobile: addressForm.Mobile,
        ClientId: loginData._id,
      };

      const response = await axios.put(
        `${Baseurl}/api/v1/client/address`,
        formData
      );

      if (response.data.success) {
        const updatedAddresses = response.data.client?.Addresses || [
          ...address,
          response.data.data,
        ];
        dispatch(updateAddress(updatedAddresses));
        setAddressShow(updatedAddresses);

        if (address.length === 0) {
          const newAddress =
            response.data.data || response.data.client?.Addresses?.[0];
          if (newAddress) {
            dispatch(currAdress(newAddress));
            setSelectedAddressId(newAddress._id);
          }
        }

        setShowAddModal(false);
        resetForm();
        alert("Address added successfully!");
      }
    } catch (error) {
      alert("Failed to add address. Please try again.");
    }
    setAddLoading(false);
  };

  const handleEditAddress = (address) => {
    setSelectedAddress(address);
    setAddressForm({
      HNo: address.HNo || "",
      AName: address.AName || "",
      StreetDet: address.StreetDet || "",
      AreaDet: address.AreaDet || "",
      LandMark: address.LandMark || "",
      City: address.City || "",
      State: address.State || "Telangana",
      Pincode: address.Pincode || "",
      Mobile: address.Mobile || "",
      Type: address.Type || "Home",
    });
    setShowEditModal(true);
  };

  const handleSaveAddress = async () => {
    if (!validateForm()) return;
    setAddLoading(true);

    try {
      const formData = {
        addressId: selectedAddress._id,
        AName: addressForm.AName,
        Number: addressForm.Mobile,
        Pincode: parseInt(addressForm.Pincode),
        State: addressForm.State,
        City: addressForm.City,
        HNo: addressForm.HNo,
        StreetDet: addressForm.StreetDet,
        LandMark: addressForm.LandMark,
        AreaDet: addressForm.AreaDet,
        Type: addressForm.Type,
        Tag: "",
        prime: selectedAddress.prime || false,
        Mobile: addressForm.Mobile,
        ClientId: loginData._id,
      };

      const response = await axios.put(
        `${Baseurl}/api/v1/client/updateclientsingleaddress`,
        formData
      );

      if (response.data.success) {
        const updatedAddresses = response.data.client.Addresses;
        dispatch(updateAddress(updatedAddresses));
        setAddressShow(updatedAddresses);

        if (selectedAddress._id === currentAddress._id) {
          const updatedAddress = updatedAddresses.find(
            (addr) => addr._id === selectedAddress._id
          );
          if (updatedAddress) {
            dispatch(currAdress(updatedAddress));
            setSelectedAddressId(updatedAddress._id);
          }
        }

        setShowEditModal(false);
        resetForm();
        alert("Address updated successfully!");
      }
    } catch (error) {
      alert("Failed to update address");
    }
    setAddLoading(false);
  };

  const handleSelectAddress = (address) => {
    dispatch(currAdress(address));
    setSelectedAddressId(address._id);
    setShowAddressModal(false);
  };

  const handleAddressSelect = (address) => {
    dispatch(currAdress(address));
    setSelectedAddressId(address._id);
  };

  const resetForm = () => {
    setAddressForm({
      HNo: "",
      AName: "",
      StreetDet: "",
      AreaDet: "",
      LandMark: "",
      City: "",
      State: "Telangana",
      Pincode: "",
      Mobile: "",
      Type: "Home",
    });
    setFormErrors({});
  };

  const AddressCard = ({ address, index }) => (
    <div
      className={`
      position-relative p-4 rounded-3 shadow-sm
      ${
        selectedAddressId === address._id
          ? "border border-primary border-2 bg-white"
          : "border border-light-subtle bg-white"
      }
    `}
      style={{
        cursor: "pointer",
        transition: "all 0.3s ease",
        minHeight: "220px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
      onClick={() => handleAddressSelect(address)}
      onMouseEnter={(e) => {
        if (selectedAddressId !== address._id) {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.1)";
        }
      }}
      onMouseLeave={(e) => {
        if (selectedAddressId !== address._id) {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
        }
      }}
    >
      {/* Address Type & User Info */}
      <div className="mb-3">
        <div className="d-flex align-items-start mb-1">
          <div className="flex-grow-1">
            {/* Name + Primary Label */}
            <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
              <h3 className="fs-5 fw-semibold text-dark mb-0">
                {loginData.Name}
              </h3>

              {selectedAddressId === address._id && (
                <span className="badge border border-primary text-primary px-2 py-1 rounded-pill fs-6 bg-white">
                  Primary
                </span>
              )}
            </div>

            <div className="text-muted small">
              {selectedAddressId === address._id
                ? "Default delivery address"
                : "Delivery address"}
            </div>
          </div>
        </div>

        {/* Address Details */}
        <div className="mb-3 ms-1">
          <div className="text-dark fw-medium mb-2 fs-6">
            {address.HNo}, {address.AName}, {address.City}, {address.State} -{" "}
            {address.Pincode}, {address.Mobile}
          </div>
          {address.StreetDet && (
            <div className="text-muted small">{address.StreetDet}</div>
          )}
          {address.LandMark && (
            <div className="text-muted small">Landmark: {address.LandMark}</div>
          )}
        </div>
      </div>

      <div className="d-flex justify-content-end align-items-center">
        <div className="d-flex gap-2 align-self-end align-self-sm-center">
          <button
            className="btn btn-outline-primary btn-sm rounded-2 px-3 py-2 d-flex align-items-center gap-2"
            onClick={(e) => {
              e.stopPropagation();
              handleEditAddress(address);
            }}
          >
            <i className="bi bi-pencil"></i>
            <span className="d-none d-sm-inline">Edit</span>
          </button>

          <button
            className="btn btn-outline-danger btn-sm rounded-2 px-3 py-2 d-flex align-items-center gap-2"
            onClick={(e) => {
              e.stopPropagation();
              setModalVisible(true);
              setSelectAddress(address);
            }}
          >
            <i className="bi bi-trash"></i>
            <span className="d-none d-sm-inline">Delete</span>
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className="min-vh-100 container bg-light"
      style={{ marginTop: "80px" }}
    >
      <div
        className="d-flex justify-content-between align-items-center px-2 rounded-1 py-2 shadow-sm mb-3"
        style={{ backgroundColor: "#aa2b57" }}
      >
        <button
          className="btn btn-light btn-sm"
          onClick={() => navigate(-1)}
          style={{ minWidth: "40px" }}
        >
          <FaChevronLeft />
        </button>
        <h1
          className="text-white fs-6 fw-semibold m-0 text-center flex-grow-1"
          style={{ letterSpacing: "0.5px" }}
        >
          Address
        </h1>
      </div>
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="container py-2">
          <div className="row align-items-center">
            {/* LEFT SECTION */}
            <div className="col-12 col-md-8 d-flex align-items-start">
              <button
                className="btn btn-link text-dark p-0 me-3"
                onClick={() => navigate(-1)}
              ></button>

              <div>
                <h1 className="fs-4 fw-bold mb-0 text-dark">
                  Manage Addresses
                </h1>
                <p className="text-muted small mb-0 mt-1">
                  Select or manage your delivery addresses
                </p>
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div className="col-12 col-md-4 text-md-end mt-3 mt-md-0">
              {addressShow.length > 0 && (
                <button
                  className="btn btn-primary rounded-3 px-4 py-2"
                  onClick={() => setShowAddModal(true)}
                >
                  Add New Address
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-5">
        <div className="row justify-content-center">
          {/* Main Content Area */}
          <div className="col-12">
            {/* Saved Addresses Grid */}
            <div className="mb-3">
              <h3 className="fs-5 fw-bold text-dark mb-4">
                Your Saved Addresses
              </h3>
              {addressShow.length > 0 ? (
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                  {addressShow.map((adrs, index) => (
                    <div key={index} className="col">
                      <AddressCard address={adrs} index={index} />
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  className="bg-white rounded-4 shadow-sm p-5 text-center"
                  style={{ maxWidth: "600px", margin: "0 auto" }}
                >
                  <div
                    className="bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
                    style={{ width: "100px", height: "100px" }}
                  >
                    <i className="bi bi-geo-alt text-muted fs-1"></i>
                  </div>
                  <h3 className="fs-4 fw-bold text-dark mb-3">
                    No Addresses Saved Yet
                  </h3>
                  <p
                    className="text-muted mb-4 mx-auto"
                    style={{ maxWidth: "500px" }}
                  >
                    You haven't saved any delivery addresses. Add your first
                    address for faster checkout and better delivery experience.
                  </p>
                  <button
                    className="btn btn-primary px-5 py-3 rounded-3 fw-medium"
                    onClick={() => setShowAddModal(true)}
                  >
                    <i className="bi bi-plus-lg me-2"></i>
                    Add Your First Address
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Select Address Modal */}
      {showAddressModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 mt-10 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: "1050" }}
          onClick={() => setShowAddressModal(false)}
        >
          <div
            className="bg-white rounded-4 shadow-lg p-4"
            style={{
              width: "550px",
              maxWidth: "90%",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="position-absolute top-0 end-0 m-3 btn-close"
              onClick={() => setShowAddressModal(false)}
            ></button>

            <h5 className="fw-bold mb-1">Select Delivery Address</h5>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                Choose from your saved addresses
              </p>
              <button
                className="btn btn-primary rounded-pill px-4 fw-semibold py-2"
                onClick={() => {
                  setShowAddressModal(false);
                  setShowAddModal(true);
                }}
                style={{ fontSize: "12px" }}
              >
                <FaPlus className="me-2" /> Add New
              </button>
            </div>

            <div>
              {addressShow.map((addr) => (
                <div
                  key={addr._id}
                  className={`p-3 rounded-3 shadow-sm mb-3 ${
                    selectedAddressId === addr._id
                      ? "border border-primary bg-primary bg-opacity-10"
                      : "border border-light bg-white"
                  }`}
                  style={{ cursor: "pointer", transition: "0.3s" }}
                  onClick={() => handleSelectAddress(addr)}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="d-flex align-items-center">
                      <div className="me-3">
                        <FaMapMarkerAlt className="text-primary" size={15} />
                      </div>
                      <div className="d-flex gap-2 align-items-center">
                        <div
                          style={{ fontSize: "14px" }}
                          className="mb-0 fw-bold"
                        >
                          {loginData?.Name}
                        </div>
                        <div
                          style={{ fontSize: "12px" }}
                          className="text-muted"
                        >
                          {addr.Type}
                        </div>
                      </div>
                    </div>
                    {selectedAddressId === addr._id && (
                      <span className="badge bg-success bg-opacity-10 text-success px-3 py-1 rounded-pill">
                        <FaCheck size={10} className="me-1" />
                        Selected
                      </span>
                    )}
                  </div>

                  <div className="mt-2 small text-dark">
                    {addr.HNo}, {addr.AName}, {addr.City}, {addr.State} -{" "}
                    {addr.Pincode}, {addr.Mobile}
                  </div>
                </div>
              ))}
            </div>

            {addressShow.length === 0 && (
              <div className="text-center py-5">
                <FaMapMarkerAlt
                  size={50}
                  className="text-muted opacity-50 mb-3"
                />
                <h6 className="fw-bold">No Addresses Found</h6>
                <p className="text-muted">Add your first address to continue</p>
                <button
                  className="btn btn-primary rounded-pill px-4 py-3"
                  onClick={() => {
                    setShowAddressModal(false);
                    setShowAddModal(true);
                  }}
                >
                  <FaPlus className="me-2" /> Add Address
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Add Address Modal */}
      {showAddModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100  d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: "1050",
            marginTop: "30px",
          }}
          onClick={() => setShowAddModal(false)}
        >
          <div
            className="bg-white rounded-4 shadow-lg"
            style={{
              width: "90%",
              maxWidth: "650px",
              maxHeight: "90vh",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-4 border-bottom">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h5 className="fw-bold text-dark mb-1">Add New Address</h5>
                  <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                    Enter your complete delivery address
                  </p>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowAddModal(false)}
                ></button>
              </div>
            </div>

            <div style={{ maxHeight: "calc(90vh - 200px)", overflowY: "auto" }}>
              <div className="p-4">
                <div className="mb-4">
                  <button
                    type="button"
                    className="btn btn-outline-primary w-100 rounded-3 py-3 fw-semibold d-flex align-items-center justify-content-center"
                    onClick={autoFillFromLocation}
                    disabled={locationLoading}
                  >
                    {locationLoading ? (
                      <>
                        <div
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></div>
                        Detecting Location...
                      </>
                    ) : (
                      <>
                        <FaCrosshairs className="me-2" /> Use Current Location
                      </>
                    )}
                  </button>
                  <div className="mt-2">
                    <small className="text-muted" style={{ fontSize: "14px" }}>
                      We'll automatically fill your address details from your
                      current location
                    </small>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      House/Flat No.*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.HNo ? "is-invalid" : ""
                      }`}
                      value={addressForm.HNo}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          HNo: e.target.value,
                        }));
                        if (formErrors.HNo)
                          setFormErrors((prev) => ({ ...prev, HNo: "" }));
                      }}
                      placeholder="Enter house/flat number"
                    />
                    {formErrors.HNo && (
                      <div className="invalid-feedback">{formErrors.HNo}</div>
                    )}
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Area Name*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.AName ? "is-invalid" : ""
                      }`}
                      value={addressForm.AName}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          AName: e.target.value,
                        }));
                        if (formErrors.AName)
                          setFormErrors((prev) => ({ ...prev, AName: "" }));
                      }}
                      placeholder="Enter area name"
                    />
                    {formErrors.AName && (
                      <div className="invalid-feedback">{formErrors.AName}</div>
                    )}
                  </div>

                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Street Details
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2"
                      value={addressForm.StreetDet}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          StreetDet: e.target.value,
                        }))
                      }
                      placeholder="Enter street details"
                    />
                  </div>

                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Area Details*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.AreaDet ? "is-invalid" : ""
                      }`}
                      value={addressForm.AreaDet}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          AreaDet: e.target.value,
                        }));
                        if (formErrors.AreaDet)
                          setFormErrors((prev) => ({ ...prev, AreaDet: "" }));
                      }}
                      placeholder="Enter area details"
                    />
                    {formErrors.AreaDet && (
                      <div className="invalid-feedback">
                        {formErrors.AreaDet}
                      </div>
                    )}
                  </div>

                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Landmark
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2"
                      value={addressForm.LandMark}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          LandMark: e.target.value,
                        }))
                      }
                      placeholder="Enter nearby landmark"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      City*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.City ? "is-invalid" : ""
                      }`}
                      value={addressForm.City}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          City: e.target.value,
                        }));
                        if (formErrors.City)
                          setFormErrors((prev) => ({ ...prev, City: "" }));
                      }}
                      placeholder="Enter city"
                    />
                    {formErrors.City && (
                      <div className="invalid-feedback">{formErrors.City}</div>
                    )}
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      State
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2"
                      value={addressForm.State}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          State: e.target.value,
                        }))
                      }
                      placeholder="Enter state"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Pincode*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.Pincode ? "is-invalid" : ""
                      }`}
                      value={addressForm.Pincode}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAddressForm((prev) => ({ ...prev, Pincode: value }));
                        if (formErrors.Pincode)
                          setFormErrors((prev) => ({ ...prev, Pincode: "" }));
                      }}
                      placeholder="6-digit pincode"
                      maxLength={6}
                    />
                    {formErrors.Pincode && (
                      <div className="invalid-feedback">
                        {formErrors.Pincode}
                      </div>
                    )}
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Mobile Number*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.Mobile ? "is-invalid" : ""
                      }`}
                      value={addressForm.Mobile}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAddressForm((prev) => ({ ...prev, Mobile: value }));
                        if (formErrors.Mobile)
                          setFormErrors((prev) => ({ ...prev, Mobile: "" }));
                      }}
                      placeholder="10-digit mobile number"
                      maxLength={10}
                    />
                    {formErrors.Mobile && (
                      <div className="invalid-feedback">
                        {formErrors.Mobile}
                      </div>
                    )}
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-semibold text-dark mb-3">
                      Address Type
                    </label>
                    <div className="d-flex gap-2 flex-wrap">
                      {["Home", "Office", "Other"].map((type) => (
                        <button
                          key={type}
                          type="button"
                          className={`btn flex-fill rounded-3 py-2 fw-semibold ${
                            addressForm.Type === type
                              ? "btn-primary"
                              : "btn-outline-primary"
                          }`}
                          onClick={() =>
                            setAddressForm((prev) => ({ ...prev, Type: type }))
                          }
                        >
                          {type}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-4 border-top bg-light">
              <div className="d-flex gap-3 justify-content-end">
                <button
                  type="button"
                  className="btn btn-outline-secondary rounded-3 px-4 py-2 fw-semibold"
                  onClick={() => setShowAddModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary rounded-3 px-4 py-2 fw-semibold"
                  onClick={handleAddAddress}
                  disabled={addLoading}
                >
                  {addLoading ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></div>
                      Adding Address...
                    </>
                  ) : (
                    "Add Address"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Address Modal */}
      {showEditModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: "1050",
            marginTop: "30px",
          }}
          onClick={() => setShowEditModal(false)}
        >
          <div
            className="bg-white rounded-4 shadow-lg"
            style={{
              width: "90%",
              maxWidth: "650px",
              maxHeight: "90vh",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-4 border-bottom">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h5 className="fw-bold text-dark mb-1">Edit Address</h5>
                  <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                    Update your delivery address details
                  </p>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>
            </div>

            <div style={{ maxHeight: "calc(90vh - 200px)", overflowY: "auto" }}>
              <div className="p-4">
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      House/Flat No.*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.HNo ? "is-invalid" : ""
                      }`}
                      value={addressForm.HNo}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          HNo: e.target.value,
                        }));
                        if (formErrors.HNo)
                          setFormErrors((prev) => ({ ...prev, HNo: "" }));
                      }}
                      placeholder="Enter house/flat number"
                    />
                    {formErrors.HNo && (
                      <div className="invalid-feedback">{formErrors.HNo}</div>
                    )}
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Area Name*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.AName ? "is-invalid" : ""
                      }`}
                      value={addressForm.AName}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          AName: e.target.value,
                        }));
                        if (formErrors.AName)
                          setFormErrors((prev) => ({ ...prev, AName: "" }));
                      }}
                      placeholder="Enter area name"
                    />
                    {formErrors.AName && (
                      <div className="invalid-feedback">{formErrors.AName}</div>
                    )}
                  </div>

                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Street Details
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2"
                      value={addressForm.StreetDet}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          StreetDet: e.target.value,
                        }))
                      }
                      placeholder="Enter street details"
                    />
                  </div>

                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Area Details*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.AreaDet ? "is-invalid" : ""
                      }`}
                      value={addressForm.AreaDet}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          AreaDet: e.target.value,
                        }));
                        if (formErrors.AreaDet)
                          setFormErrors((prev) => ({ ...prev, AreaDet: "" }));
                      }}
                      placeholder="Enter area details"
                    />
                    {formErrors.AreaDet && (
                      <div className="invalid-feedback">
                        {formErrors.AreaDet}
                      </div>
                    )}
                  </div>

                  <div className="col-12">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Landmark
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2"
                      value={addressForm.LandMark}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          LandMark: e.target.value,
                        }))
                      }
                      placeholder="Enter nearby landmark"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      City*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.City ? "is-invalid" : ""
                      }`}
                      value={addressForm.City}
                      onChange={(e) => {
                        setAddressForm((prev) => ({
                          ...prev,
                          City: e.target.value,
                        }));
                        if (formErrors.City)
                          setFormErrors((prev) => ({ ...prev, City: "" }));
                      }}
                      placeholder="Enter city"
                    />
                    {formErrors.City && (
                      <div className="invalid-feedback">{formErrors.City}</div>
                    )}
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      State
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2"
                      value={addressForm.State}
                      onChange={(e) =>
                        setAddressForm((prev) => ({
                          ...prev,
                          State: e.target.value,
                        }))
                      }
                      placeholder="Enter state"
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Pincode*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.Pincode ? "is-invalid" : ""
                      }`}
                      value={addressForm.Pincode}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAddressForm((prev) => ({ ...prev, Pincode: value }));
                        if (formErrors.Pincode)
                          setFormErrors((prev) => ({ ...prev, Pincode: "" }));
                      }}
                      placeholder="6-digit pincode"
                      maxLength={6}
                    />
                    {formErrors.Pincode && (
                      <div className="invalid-feedback">
                        {formErrors.Pincode}
                      </div>
                    )}
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      className="form-label fw-semibold text-dark"
                      style={{ fontSize: "12px" }}
                    >
                      Mobile Number*
                    </label>
                    <input
                      type="text"
                      className={`form-control rounded-3 py-2 ${
                        formErrors.Mobile ? "is-invalid" : ""
                      }`}
                      value={addressForm.Mobile}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setAddressForm((prev) => ({ ...prev, Mobile: value }));
                        if (formErrors.Mobile)
                          setFormErrors((prev) => ({ ...prev, Mobile: "" }));
                      }}
                      placeholder="10-digit mobile number"
                      maxLength={10}
                    />
                    {formErrors.Mobile && (
                      <div className="invalid-feedback">
                        {formErrors.Mobile}
                      </div>
                    )}
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-semibold text-dark mb-3">
                      Address Type
                    </label>
                    <div className="d-flex gap-2 flex-wrap">
                      {["Home", "Office", "Other"].map((type) => (
                        <button
                          key={type}
                          type="button"
                          className={`btn flex-fill rounded-3 py-2 fw-semibold ${
                            addressForm.Type === type
                              ? "btn-primary"
                              : "btn-outline-primary"
                          }`}
                          onClick={() =>
                            setAddressForm((prev) => ({ ...prev, Type: type }))
                          }
                        >
                          {type}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-4 border-top bg-light">
              <div className="d-flex gap-3 justify-content-end">
                <button
                  type="button"
                  className="btn btn-outline-secondary rounded-3 px-4 py-2 fw-semibold"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary rounded-3 px-4 py-2 fw-semibold"
                  onClick={handleSaveAddress}
                  disabled={addLoading}
                >
                  {addLoading ? (
                    <>
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></div>
                      Updating Address...
                    </>
                  ) : (
                    "Update Address"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {modalVisible && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: "1060" }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setModalVisible(false);
            }
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 p-4 pb-0">
                <div className="d-flex align-items-center gap-3 w-100">
                  <div className="flex-grow-1">
                    <h5 className="modal-title fs-5 fw-bold text-dark">
                      Delete Address
                    </h5>
                    <p className="text-muted small mb-0">
                      Are you sure you want to delete this address?
                    </p>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setModalVisible(false)}
                  ></button>
                </div>
              </div>

              <div className="modal-body p-4">
                {selectAddress && (
                  <div className="bg-light rounded-3 p-3 mb-4 border border-light-subtle">
                    <div className="d-flex align-items-start gap-3">
                      <div className="flex-grow-1">
                        <div className="fw-medium text-dark mb-1">
                          {selectAddress.AName}
                        </div>
                        <div className="text-muted small mb-1">
                          {selectAddress.HNo}
                        </div>
                        <div className="text-muted small">
                          {selectAddress.City}, {selectAddress.State} -{" "}
                          {selectAddress.Pincode}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="alert alert-warning border-warning bg-warning bg-opacity-10 mb-0">
                  <div className="d-flex">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    <div>
                      <span className="fw-medium">Warning:</span> This action
                      cannot be undone. The address will be permanently removed
                      from your account.
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer border-top-0 p-4 pt-0">
                <div className="d-flex gap-3 w-100">
                  <button
                    className="btn btn-outline-secondary flex-grow-1 py-2 rounded-3"
                    onClick={() => setModalVisible(false)}
                    disabled={isDeleting}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-danger flex-grow-1 py-2 rounded-3 d-flex align-items-center justify-content-center gap-2"
                    onClick={deleteClick}
                    disabled={isDeleting}
                  >
                    {isDeleting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        ></span>
                        Deleting...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-trash"></i>
                        Delete Address
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Address;
